export type DomainErrorCode =
  | 'not_found'
  | 'invalid_reference'
  | 'invalid_operation'
  | 'validation'
  | 'limit_exceeded'

export class DomainError extends Error {
  readonly code: DomainErrorCode
  readonly details: Record<string, string> | undefined

  constructor(code: DomainErrorCode, message: string, details?: Record<string, string>) {
    super(message)
    this.name = 'DomainError'
    this.code = code
    this.details = details
  }
}

export function assertFound<T>(value: T | undefined, kind: string, id: string): T {
  if (value === undefined) {
    throw new DomainError('not_found', `${kind} ${id} does not exist on this board`)
  }
  return value
}
